var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('div',[_vm._v("test "),_c('button',{on:{"click":_vm.showDialogAlert}},[_vm._v("alert")]),_c('button',{on:{"click":_vm.showDialogAlert2}},[_vm._v("alert 2")]),_c('button',[_vm._v("Browse")]),_c('button',{on:{"click":_vm.takePicture}},[_vm._v("Camera")]),_vm._v(" "+_vm._s(_vm.imgUrl)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }